import { TemplateConfig } from '../../template-config.interface';

export const macroCTV: TemplateConfig = {
  id: 'macro-ctv',
  clientId: 'MACRO',
  title: 'Demo Macro',
  description: 'Template para contenido CTV',
  aspectRatio: 'horizontal',
  image: 'https://media.backend.doer.ar/brands/assets/MACRO/templates/thumbnails/ctv/ctv_1920x1080.png',
  optimized_image:
    'https://media.backend.doer.ar/brands/assets/MACRO/templates/thumbnails/ctv/optimized/ctv_1920x1080.png',

  video: '',
  video_300x600: 'https://media.backend.doer.ar/brands/assets/MACRO/templates/previews/macro-ctv/macro-ctv_300x600.mp4',
  video_300x250: 'https://media.backend.doer.ar/brands/assets/MACRO/templates/previews/macro-ctv/macro-ctv_300x250.mp4',
  video_1080x1080:
    'https://media.backend.doer.ar/brands/assets/MACRO/templates/previews/macro-ctv/macro-ctv_1080x1080.mp4',
  video_1080x1350:
    'https://media.backend.doer.ar/brands/assets/MACRO/templates/previews/macro-ctv/macro-ctv_1080x1350.mp4',
  video_1920x1080:
    'https://media.backend.doer.ar/brands/assets/MACRO/templates/previews/macro-ctv/macro-ctv_1920x1080.mp4',

  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'text',
      label: 'Slogan (opcional)',
      type: 'input',
      placeholder: 'Máx. 20 caracteres por línea. Presioná Enter para saltos de línea.',
      required: false,
      multiline: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/description.png'
    },
    {
      key: 'video',
      label: 'Video',
      type: 'video',
      placeholder: 'https://cdn.filestackcontent.com/...',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/video.png'
    },
    {
      key: 'background',
      label: 'Imagen de fondo',
      type: 'select',
      options: [
        {
          value: 'https://media.backend.doer.ar/brands/assets/MACRO/templates/thumbnails/ctv/fondo.png',
          label: 'Fondo azul'
        }
      ],
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/background.png'
    },
    {
      key: 'logo',
      label: 'Logo (opcional)',
      type: 'visual-select',
      required: false,
      options: [
        {
          value: 'https://media.backend.doer.ar/brands/assets/MACRO/templates/thumbnails/ctv/logo_macro.png',
          label: 'Logo 1',
          backgroundColor: '#0139E3'
        },
        {
          value: 'https://media.backend.doer.ar/brands/assets/MACRO/templates/thumbnails/ctv/logo_macro_w.png',
          label: 'Logo 2',
          backgroundColor: '#0139E3'
        }
      ],
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/logo.png'
    }
  ],

  promptTemplate: `Haceme un video CTV, usando este video: "https://media.backend.doer.ar/brands/assets/MACRO/examples/ctv/macro.mp4",
Con este texto:
"Sabemos lo
que valemos
los argentinos",
Con este logo: "https://media.backend.doer.ar/brands/assets/MACRO/examples/ctv/macro.png",
y este fondo: "https://media.backend.doer.ar/brands/assets/MACRO/examples/ctv/fondo.png"`
};
